import { useEffect, useState } from 'react'
import type { Session } from '../api/types'
import { errorMessage } from '../api/client'
import { useBoardState, useStore } from '../store/context'
import { useMounted } from '../components/layout'

/** A spent budget stays editable before the session resumes. */
export function BudgetSettings({session}: {session: Session}) {
  const store = useStore()
  const {offline} = useBoardState()
  const mounted = useMounted()
  const [turns, setTurns] = useState('')
  const [minutes, setMinutes] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)
  useEffect(() => {
    setTurns(session.allowance?.budget?.turns?.toString() ?? '')
    setMinutes(session.allowance?.budget?.minutes?.toString() ?? '')
  }, [session.id, session.allowance?.budget?.turns, session.allowance?.budget?.minutes])
  const budget = {turns: turns === '' ? null : Number(turns), minutes: minutes === '' ? null : Number(minutes)}
  const valid = Object.values(budget).every(n => n === null || (Number.isInteger(n) && n > 0 && n <= 100_000))
  const save = async () => {
    if (saving || offline || !valid) return
    setSaving(true)
    setError(null)
    try { await store.sendSessionOp({mutation_id: crypto.randomUUID(), op:'set_session_budget', args:{session_id:session.id,budget}}) }
    catch (error) { if (mounted.current) setError(errorMessage(error)) }
    finally { if (mounted.current) setSaving(false) }
  }
  return <details className="code-budget-settings">
    <summary>Budget{session.allowance?.stopped ? ' · Spent' : ''}</summary>
    <div className="code-dialog-row">
      <label className="field"><span>Turns</span><input type="number" min="1" max="100000" step="1" value={turns} onChange={event => setTurns(event.target.value)} placeholder="No limit" disabled={saving || offline}/></label>
      <label className="field"><span>Minutes</span><input type="number" min="1" max="100000" step="1" value={minutes} onChange={event => setMinutes(event.target.value)} placeholder="No limit" disabled={saving || offline}/></label>
    </div>
    <button type="button" className="button button-small" disabled={saving || offline || !valid} onClick={() => void save()}>Save budget</button>
    {error && <p role="alert">{error}</p>}
  </details>
}
